export default "__VITE_ASSET__CFOVlASI__"